import Spinner from "react-bootstrap/Spinner";

function GrowSpinner({ className }) {
  return (
    <div className={`${className}`}>
      <Spinner animation="grow" />
    </div>
  );
}

export default GrowSpinner;
